import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Image } from '@cian/ui-kit';

import * as s from './NotFound.css';

/** Заглушка 404 */
export const NotFound = () => {
  const history = useHistory();

  const handleClick = () => {
    history.push('/magazine/');
  };

  return (
    <div className={`${s['wrapper']}`}>
      <Link to={'/magazine/'}>
        <Image
          alt={'Страница не найдена'}
          borderRadius={0}
          objectFit="cover"
          src={'//cdn.cian.site/frontend/frontend-status-pages/logo_glitch.gif'}
          theme="light"
          title={'Страница не найдена'}
        />
      </Link>

      <div className={`${s['info']}`}>
        <div className={`${s['title']}`}>Страница не найдена</div>

        <div className={`${s['description']}`}>
          Возможно, у вас опечатка в адресе страницы, или её просто не существует :(
        </div>

        <div className={`${s['button-wrapper']}`}>
          <Button size="L" onClick={handleClick}>
            Перейти на главную
          </Button>
        </div>

        <div className={`${s['error-code']}`}>Ошибка 404</div>
      </div>
    </div>
  );
};
